
import { Box, Button, Card, CardActions, CardContent, Grid, Stack, styled, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useState } from 'react';
import data from '../../Utilities/Test/base64';
import base64 from '../../Utilities/Test/base64';


const DownLoadButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText('#0d409b'),
    backgroundColor: '#0d409b',
    border: '1px solid',
    borderRadius: '24px',
    '&:hover': {
        backgroundColor: '#0d409b',
    },
}));

const BackButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText('#fafafa'),
    backgroundColor: '#fafafa',
    border: '1px solid',
    borderRadius: '24px',
    '&:hover': {
        backgroundColor: '#fafafa',
    },
}));

function downloadFile(base64String, filename) {
   // const file = new Blob([atob(base64String)], {type: 'application/octet-stream'});
    const linkSource = `data:application/pdf;base64,${base64String}`;

    const link = document.createElement('a');
    console.log('ddd',link,linkSource)
    //link.href = URL.createObjectURL(linkSource);
    link.href = linkSource
    link.download = filename;
    document.body.appendChild(link);
    link.click();
  }


  function downloadPDF(pdf) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    const fileName = "file.pdf";

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
}

const SuccesStatus = (props) => {

    const { data } = props
    const [base64ContentString,setBase64ContentString] = useState('')


    const downLoadPolicyProposal = () => {

    }
    const downLoadPolicy = () => {
        console.log('clicked donload')
        //downloadFile(data,'policy.pdf')
        downloadPDF(data.pdf)

    }
    const downLoadPolicy_Ecard = () => {

    }

    const goToHome = () => {
        window.open('','_self').close()
    }

    useEffect(() => {

        setBase64ContentString(data)

    }, [])

    


    return (
        <>
            <div className="header-sec">
                <p className="insurence-title">
                    Health Insurance <KeyboardArrowDownIcon />
                </p>
            </div>
            <Box sx={{ padding: '16px', marginTop: '16px' }}>
                <Card >
                    <CardContent>
                        <Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '16px', }}>

                                <Typography variant='h6' color='green'
                                    sx={{ fontWeight: 600 }}
                                >
                                    Transaction Successfull
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '16px', }}>
                                <CheckCircleOutlineRoundedIcon
                                    style={{ color: "green", fontSize: "40px", }}
                                />
                            </Box>
                            <Box sx={{ padding: '28px', marginTop: '16px', }}>
                                <Grid container spacing={2} >
                                    <Grid item xs={6}>
                                        <Typography
                                            sx={{ fontWeight: 400, textTransform: 'capitalize' }}
                                        >
                                            Transaction Id
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography>
                                            {"N/A"}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography
                                            sx={{ fontWeight: 400, textTransform: 'capitalize' }}
                                        >
                                            policy no
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography>
                                            {data.policyNumber}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Box>

                        </Box>

                    </CardContent>
                </Card>
                <Stack spacing={2} sx={{ padding: '16px', marginTop: '16px' }}>
                    {/* <DownLoadButton>DownLoad policy proposal</DownLoadButton> */}
                    <DownLoadButton onClick={downLoadPolicy}>DownLoad policy </DownLoadButton>
                   {/*  <embed src={`data:application/pdf;base64,${base64ContentString}`}  type="application/pdf" width="100%">Download</embed> */}
                    {/*  <DownLoadButton>Download policy E-card</DownLoadButton> */}
                    <BackButton onClick={goToHome}>back to home</BackButton>
                </Stack>
            </Box>
        </>
    )
}

export default SuccesStatus